import React, { Component, useMemo, createRef } from 'react';
import InputKeyboard from '../InputKeyboard';
import _ from "lodash";
import moment from "moment";
import {Link} from 'react-router';
import {t} from "../../../../dev/helpers/translator";
class InputKeyboardBounced extends Component {
    constructor (props) {
        super(props);
        this.state = {
            value: ""
        };
        this.inputRef = createRef();
        this.emptyvalue = this.emptyvalue.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeBounce = _.debounce(this.props.handleChangeBounce, 1000);
    }
    emptyvalue () {
        this.setState({value: "yhyhyhyhyh"});
    }
    handleChange (value) {
        this.setState({
            value
        }, () => {
            this.handleChangeBounce(value);
        });
    }
    render () {
        const CustomMapping = [
            ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
            ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '@'],
            ['z', 'x', 'c', 'v', 'b', 'n', 'm']
        ];
        return <div className="game-search-input" onClick={this.props.searchDataKeep} >
            <InputKeyboard
                enabled
                onChange={this.handleChange}
                value={this.state.value}
                name="myInput"
                placeholder={t("Type to search...")}
                defaultKeyboard={CustomMapping}
                isDraggable={false}
                isFirstLetterUppercase={false}
            />
        </div>;
    }
}

export default function headerSearch () {
    //console.log(this.state);
    return (
        <React.Fragment>
            <i onClick={this.showSearch} className={`search-icon ${!this.state.showSearchIcon ? "enabled" : ""}`}></i>
            {
                !this.state.showSearchIcon && <InputKeyboardBounced handleChangeBounce={this.handleChange} searchDataKeep = {this.dataMemoizing} this={self}/>
            }
            {
                !this.state.loading && this.state.data && (Object.keys(this.state.data.data.sport).length !== 0 ? <ResponseData self={this} data={this.state.data.data.sport} /> : <div className='search-container-no-data'><p>{t("No Result")}</p></div>)
            }
        </React.Fragment>
    );
}

function ResponseData ({self, data}) {
    const newData = useMemo(() => {
        const newData = [];
        Object.keys(data).filter(item => Object.prototype.hasOwnProperty.call(data, item)).map(item => {
            const sport = data[item];
            Object.keys(sport.region).filter(item => Object.prototype.hasOwnProperty.call(sport.region, item)).map(item => {
                const region = sport.region[item];
                Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.competition, item)).map(item => {
                    const competition = region.competition[item];
                    Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).map(item => {
                        const game = competition.game[item];
                        newData.push({
                            ...game,
                            sportAlias: sport.alias,
                            sportName: sport.name,
                            sportType: sport.type,
                            sportOrder: sport.order,
                            regionId: region.id,
                            regionAlias: region.alias,
                            regionName: region.name,
                            competitionId: competition.id,
                            competitionName: competition.name,
                            gameId: game.id
                        });
                    });
                });
            });
        });
        return _.groupBy(newData, 'sportOrder');
    }, [data]);
    console.log(newData);
    return (
        <div className='search-container' ref={self.referanc} >
            <ul>
            {
                Object.values(newData).map((item) => { return item[0].sportName !== "VirtualHorseRacing" ? <li className='single-game-event'><p className='alias-name'>{item[0].sportName}</p><DropDownMenu data = {item} /></li> : null;})
            }
            </ul>
        </div>
    );
}
function DropDownMenu (data) {
    return data.data.map((el) => {
        if (el.sportType === 1) {
            return;
        } return <Link className="resault-m-b" to={`/${el.type === 2 || el.type === 0 ? "prematch" : "live"}/${el.sportAlias}/${el.regionId}/${el.competitionId}/${el.gameId}`}>
        <p className='team-name-res-search'>
        <span>{
            el.type === 1 && el.info ? <p className='teamnames-versus'><span className='live-icon'></span>{el.team1_name ? el.team1_name : null} { el.team2_name ? " : " + el.team2_name : null}</p>
            : <i className='teamnames-versus'>{el.team1_name ? el.team1_name : null} { el.team2_name ? " : " + el.team2_name : null}</i>
        }
            <b className='region-name'>{el.competitionName}</b>
        </span>
        <span>{
            el.type === 1 && el.info ? <span className='time-to-start'>{el.info.score1 + " : " + el.info.score2} <span className='live-time'>{el.info.current_game_time} min. {el.info.current_game_state ? el.info.current_game_state : null }</span></span>
            : <b className='time-to-start'> {el.start_ts ? moment.unix(el.start_ts).format("LL") : null}</b>
        }
        </span>
            </p>
        </Link>;
    });
}